<template>
  <div>
    <div class="air__utils__heading">
      <h5>Dashboard Recebimento</h5>
    </div>
    <div class="row">
      <div class="col-xl-6 col-lg-12">
        <div class="card card-total">
          <div class="card-body">
            <ReceivementTotal :total="total" />
          </div>
        </div>
      </div>

      <div class="col-xl-6 col-lg-12">
        <div class="card card-subtotal">
          <div class="card-body">
            <ReceivementToday :total="totalToday" />
            <br />
            <ReceivementFuture :total="totalFuture" />
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <div class="row">
      <div class="col-xl-6 col-lg-12">
        <div class="card">
          <div class="card-body">
            <ReceivementSchedule :items="payoutLot" />
          </div>
        </div>
      </div>
      <div class="col-xl-6 col-lg-12">
        <div class="card">
          <div class="card-body">
            <ReceivementSimulation />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import _ from "lodash";
import ReceivementFuture from "@/components/receivement/future.vue";
import ReceivementTotal from "@/components/receivement/total.vue";
import ReceivementToday from "@/components/receivement/today.vue";
import ReceivementSchedule from "@/components/receivement/schedule.vue";
import ReceivementSimulation from "@/components/receivement/simulation.vue";
import products from "./data.json";
import { PayoutLotResource } from "@/resources/PayoutLot.resource.js";

export default {
  components: {
    ReceivementFuture,
    ReceivementTotal,
    ReceivementToday,
    ReceivementSchedule,
    ReceivementSimulation
  },
  data: function() {
    return {
      products,
      moment,
      loading: false,
      range: 5,
      payoutLot: []
    };
  },
  computed: {
    total() {
      return this.payoutLot.reduce((acc, cv) => {
        return acc + cv.netAmountTotal;
      }, 0);
    },
    totalToday() {
      const v = this;
      const today = moment();

      // faz o select dos dados
      const itens = _.filter(v.payoutLot, function(o) {
        return v.moment(o.dtPayment).format("yyyyMMdd") == today.format('yyyyMMdd')
                
      });

      return itens.reduce((acc, cv) => {
        return acc + cv.netAmountTotal;
      }, 0);
    },
    totalFuture() {
      return this.total - this.totalToday;
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      const today = moment();
      const v = this;
      const payload = {
        dtStart: today.startOf("day").format("yyyy-MM-DDT00:00:00"),
        dtEnd: today.add(this.range, "day").format("yyyy-MM-DDT23:59:59")
      };
      PayoutLotResource.getLista(payload)
        .then(result => {
          try {
            v.payoutLot = result.data.payload.items;
            v.loading = false;
          } catch (e) {
            throw {
              response: {
                data: {
                  failureReason: "erro ao realizar chamada"
                }
              }
            };
          }
        })
        .catch(e => {
          // Surpress
          v.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  &.card-total {
    height: calc(100% - 30px);
    .card-body {
      display: flex;
      .align-items-center {
        flex: 1;
      }
    }
  }
  &.card-subtotal {
    height: calc(100% - 30px);
  }
}
</style>
